/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams';

export class CreateJobTemplateInput {
  /**
  * The name of the job template
  */
  'name': string;
  /**
  * A description of the job template
  */
  'description'?: string;
  /**
  * Job timeout in seconds
  */
  'jobTimeout'?: number;
  'retryPolicy'?: SparkJobRetryPolicy | null;
  'sparkSubmitParams': SparkJobSparkSubmitParams;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "jobTimeout",
      "baseName": "jobTimeout",
      "type": "number",
      "format": ""
    },
    {
      "name": "retryPolicy",
      "baseName": "retryPolicy",
      "type": "SparkJobRetryPolicy",
      "format": ""
    },
    {
      "name": "sparkSubmitParams",
      "baseName": "sparkSubmitParams",
      "type": "SparkJobSparkSubmitParams",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateJobTemplateInput.attributeTypeMap;
  }

  public constructor() {
  }
}

